import { createSelector } from '@ngrx/store';
import { getStorePageState } from '../store.selectors';

export const getStoreProductsState = createSelector(
  getStorePageState,
  (state) => state.productsState
);
export const getStoreProductsIsLoading = createSelector(
  getStoreProductsState,
  (products) => products.isLoading
);
export const getStoreProductsData = createSelector(
  getStoreProductsState,
  (products) => products.data
);
export const getStoreProductsHasBeenFetched = createSelector(
  getStoreProductsState,
  (products) => products.fetched
);
export const getStoreProductsError = createSelector(
  getStoreProductsState,
  (products) => products.error
);
export const getStoreProductsSuccess = createSelector(
  getStoreProductsState,
  (products) => products.success
);
